import { render, staticRenderFns } from "./EntitiesList.vue?vue&type=template&id=2446628a&scoped=true&"
import script from "./EntitiesList.vue?vue&type=script&lang=js&"
export * from "./EntitiesList.vue?vue&type=script&lang=js&"
import style0 from "./EntitiesList.vue?vue&type=style&index=0&id=2446628a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2446628a",
  null
  
)

export default component.exports